// eslint-disable-next-line no-shadow
export enum LOGIN_NAVIGATION_MAP {
  WELCOME = 0,
  VERIFICATION_CODE,
  RESEND_VERIFICATION,
  NOT_FINISH_SIGN_UP,
  TAKE_5,
  TOOK_A_BREAK,
  HELP,
  HOME,
  PASSWORD_EXPIRED,
}
